import React from 'react';
import {Button, ButtonVariant} from '@amzn/stencil-react-components/button';
import {FlyoutContent, WithFlyout} from '@amzn/stencil-react-components/flyout';
import {useTranslation} from 'react-i18next';
import TranslationKeys from 'src/constants/translation-keys';
import { IconQuestionCircleSmall } from '@amzn/stencil-react-icons';
import HelpContent from './HelpContent';
import { token } from '@amzn/stencil-design-tokens/js/web/utils';

type Props = {
    buttonText: string,
    hideButtonIcon?: boolean
}

export default function GetHelpFlyout({buttonText, hideButtonIcon}: Props) {
    const { t } = useTranslation();

    const renderFlyout = ({ close }: { close: () => void }) => (
        <FlyoutContent
            titleText={t(TranslationKeys.HELP.TITLE_HEADER)}
            onCloseButtonClick={close} 
            buttons={[
                <Button data-testid="get-help-flyout-close-button"
                        onClick={close}
                        key={'close-button-key'}
                        variant={ButtonVariant.Primary}>
                     {t(TranslationKeys.UI.BUTTONS.CLOSE)}
                </Button>
            ]}>
            <HelpContent />
        </FlyoutContent>
    );

    return (
        <WithFlyout renderFlyout={renderFlyout}>
            {({open}) => (
                <Button variant={ButtonVariant.TertiaryInline}
                        data-testid="get-help-flyout-button"
                        onClick={open}
                        style={{color: token('color.link.primary-default')}}
                        icon={hideButtonIcon ? undefined : <IconQuestionCircleSmall aria-hidden={true} />}>
                    <span data-testid="text-get-help">{buttonText}</span>
                </Button>
            )}
        </WithFlyout>
    );
}
